var header = new Vue({
    el: '#mobile-category-detail',
    delimiters: ['${', '}'],
    data:{
        tab:0,
        smKey:0,
        listBig:[],
        listSm:[],
    },
    methods: {
        bigTab:function (key){
            if(key === this.tab)
            {
                return 'left-arrow';
            }else {
                return 'left-arrow hidden';
            }
        },
        bigTabClick:function (key){
            this.tab = key
            this.smKey = 0
            var set = document.getElementById('m-category-big-img').getAttribute('data-'+this.tab)
            document.getElementById('m-category-big-img').setAttribute('src',set)
        },
        smTab:function (key){
            if(key === this.smKey)
            {
                return 'category-name category-active';
            }else {
                return 'category-name';
            }
        },
        chooseSm:function (key){
            this.smKey = key
        },
        decodeQuery: function () {
            var params = {};
            var queryStr = window.location.search.replace(/^\?/, "");
            var queryArr = queryStr.split("&");
            for (var i = 0; i < queryArr.length; i++) {
                var item = queryArr[i].split("=");
                if (item[0] && item[1]) params[item[0]] = item[1];
            }
            return params;
        },
    },
    mounted(){
        var _this = this
        $.ajax({
            type:'POST',
            dataType: 'json',
            timeout: 1000,
            url: window.api.category,
            success: function (response){
                console.log(response)
                var data = response.data
                var sm = [];
                _this.listBig = Object.keys(data);
                Object.keys(data).forEach(function (key){
                    sm.push(data[key])
                });
                _this.listSm = sm;
            }
        });
        var query = this.decodeQuery()
        if(typeof (query.ckey) !== "undefined")
        {
            this.tab = parseInt(query.ckey)
        }
    }
})